'use es6';

export var TRACK_EVENT = '@@hublytics';